import Img2xs from '@images/mobile_images_gen/plans_images/plan_1.webp';
import Img3xs from '@images/mobile_images_gen/plans_images/plan_2.webp';
import Img4xs from '@images/mobile_images_gen/plans_images/plan_3.webp';
import Img5xs from '@images/mobile_images_gen/plans_images/plan_4.webp';
import Img11xs from '@images/mobile_images_gen/plans_images/plan_5.webp';
import PanoramaEvening from '@images/panorama/1_full.webp';
import PanoramaMorning from '@images/panorama/2_full.webp';
import PanoramaAfternoon from '@images/panorama/3_full.webp';
import Img2 from '@images/renders/plans_images/plan_1.webp';
import Plug1 from '@images/renders/plans_images/plan_1_plug.webp';
import Img3 from '@images/renders/plans_images/plan_2.webp';
import Plug2 from '@images/renders/plans_images/plan_2_plug.webp';
import Img4 from '@images/renders/plans_images/plan_3.webp';
import Plug3 from '@images/renders/plans_images/plan_3_plug.webp';
import Img5 from '@images/renders/plans_images/plan_4.webp';
import Plug4 from '@images/renders/plans_images/plan_4_plug.webp';
import Img11 from '@images/renders/plans_images/plan_5.webp';
import Plug5 from '@images/renders/plans_images/plan_5_plug.webp';
import Img1 from '@images/renders/slider_images/slider_1.webp';
import Img1_mob from '@images/renders/slider_images/slider_1_mob.webp';
import Img6 from '@images/renders/slider_images/slider_2.webp';
import Img6_mob from '@images/renders/slider_images/slider_2_mob.webp';
import imgPlugSlider2 from '@images/renders/slider_images/slider_2_plug.webp';
import Img7 from '@images/renders/slider_images/slider_3.webp';
import Img7_mob from '@images/renders/slider_images/slider_3_mob.webp';
import imgPlugSlider3 from '@images/renders/slider_images/slider_3_plug.webp';
import Img8 from '@images/renders/slider_images/slider_4.webp';
import Img8_mob from '@images/renders/slider_images/slider_4_mob.webp';
import imgPlugSlider4 from '@images/renders/slider_images/slider_4_plug.webp';
import Img9 from '@images/renders/slider_images/slider_5.webp';
import Img9_mob from '@images/renders/slider_images/slider_5_mob.webp';
import imgPlugSlider5 from '@images/renders/slider_images/slider_5_plug.webp';
import Img10 from '@images/renders/slider_images/slider_6.webp';
import Img10_mob from '@images/renders/slider_images/slider_6_mob.webp';
import imgPlugSlider6 from '@images/renders/slider_images/slider_6_plug.webp';
import Img_7 from '@images/renders/slider_images/slider_7.webp';
import Img_7_mob from '@images/renders/slider_images/slider_7_mob.webp';

import api from '@lib/api';
import { fetchServer } from '@lib/api/fetch-server';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchMenuLeft = createAsyncThunk('projectSlice/fetchMenuLeft', async () => fetchServer(api.urlMenuLeft));

export const fetchMenuRight = createAsyncThunk('projectSlice/fetchMenuRight', async () =>
  fetchServer(api.urlMenuRight),
);

export const fetchFooterLeft = createAsyncThunk('projectSlice/fetchFooterLeft', async () =>
  fetchServer(api.urlFooterLeft),
);

export const fetchFooterMiddle = createAsyncThunk('projectSlice/fetchFooterMiddle', async () =>
  fetchServer(api.urlFooterMiddle),
);

export const fetchFooterRight = createAsyncThunk('projectSlice/fetchFooterRight', async () =>
  fetchServer(api.urlFooterRight),
);

export const fetchDevelopers = createAsyncThunk('projectSlice/fetchDevelopers', async () =>
  fetchServer(api.urlDevelopers, { cache: 'no-store' }),
);

export const fetchPromoCards = createAsyncThunk('projectSclice/fetchPromoCards', async () =>
  fetchServer(api.urlPromoCards),
);

export const fetchGeneralSettings = createAsyncThunk('projectSlice/fetchGeneralSettings', async () =>
  fetchServer(api.urlGeneralSettings),
);

export const fetchHeaderKeysData = createAsyncThunk('projectSlice/fetchHeaderKeysData', async () =>
  fetchServer(api.urlHeaderKeysData),
);

const initialState = {
  slider: [
    {
      id: 0,
      title: '<p>Наслаждайтесь</p><p>прогулкой во дворе</p>',
      subTitle: 'Сюжетная линия незабываемых моментов',
      src: Img1,
      srcMob: Img1_mob,
      description:
        'Иммерсивное благоустройство от&nbsp;британского бюро Gillespies сфокусировано на&nbsp;эмоциональном и&nbsp;чувственном опыте. Каждая прогулка по&nbsp;Моментс погружает в&nbsp;путешествие со&nbsp;сменой сценариев и&nbsp;плавным потоком уникальных моментов.',
      active: true,
    },
    {
      id: 1,
      title: '<p>Наслаждайтесь</p><p>прогулкой в парке</p>',
      subTitle: 'Везде есть место для игp',
      src: Img6,
      srcMob: Img6_mob,
      description:
        'Игровые элементы из натуральных материалов интегрированы в насыщенный эколандшафт. Для малышей предусмотрены тихие зелёные площадки у дома. Для подростков — парк активностей с полосой препятствий, балансировочными бревнами и переговорными трубами, погружающие ребенка в мир воображения.',
      active: false,
      plug: imgPlugSlider2,
    },
    {
      id: 2,
      title: '<p>Наслаждайтесь</p><p>прогулкой в городе</p>',
      subTitle: 'В школу и сад с удовольствием',
      src: Img7,
      srcMob: Img7_mob,
      description:
        'Своя школа на&nbsp;350 мест и&nbsp;детский сад на&nbsp;175 мест вдохновляют учиться и&nbsp;познавать мир через его красоту. Лужайки и&nbsp;холмы для отдыха, классы на&nbsp;свежем воздухе, развивающие площадки и&nbsp;сенсорные сады, современное спортивное оборудование, поле для командных игр и&nbsp;матчей.',
      active: false,
      plug: imgPlugSlider3,
    },
    {
      id: 3,
      title: '<p>Наслаждайтесь</p><p>прогулкой во дворе</p>',
      subTitle: 'Всё внутри квартала',
      src: Img8,
      srcMob: Img8_mob,
      description:
        'Сбалансированная инфраструктура позволит планировать свой день и&nbsp;вычёркивать списки дел без суеты. Супермаркет, салон красоты, аптека и&nbsp;прочие полезности на&nbsp;первых этажах. Кофейни, пекарни, ресторанчики и&nbsp;семейные кафе вдоль прогулочных зон.',
      active: false,
      plug: imgPlugSlider4,
    },
    {
      id: 4,
      title: '<p>Наслаждайтесь</p><p>прогулкой во дворе</p>',
      subTitle: 'Лобби для релакса и работы',
      src: Img9,
      srcMob: Img9_mob,
      description:
        'В&nbsp;просторных лобби с&nbsp;панорамными видами на&nbsp;пышный сад всё продумано до&nbsp;мелочей: гостеприимные лаундж-зоны с&nbsp;мягкой мебелью, уютный коворкинг, ресепшн, почтовая, гостевые санузлы, удобный лифтовый холл, лапомойка, детская игровая и&nbsp;колясочная для мам с маленькими детьми.',
      active: false,
      plug: imgPlugSlider5,
    },
    {
      id: 5,
      title: '<p>Наслаждайтесь</p><p>прогулкой во дворе</p>',
      subTitle: 'Место для авто и больших вещей      ',
      src: Img10,
      srcMob: Img10_mob,
      description:
        'Сезонные вещи, велосипеды, самокаты, сноуборды, вейк или сап-борд смогут поселиться во&nbsp;вместительных кладовых. Лифт от&nbsp;квартиры моментально доставит в&nbsp;тёплый подземный паркинг. Дождь, сугробы, поиск свободного места&nbsp;&mdash; об&nbsp;этом в&nbsp;Моментс можно не&nbsp;волноваться.',
      active: false,
      plug: imgPlugSlider6,
    },
    {
      id: 6,
      title: '<p>Наслаждайтесь</p><p>прогулкой во дворе</p>',
      subTitle: 'Всё для безопасности и комфорта      ',
      src: Img_7,
      srcMob: Img_7_mob,
      description:
        'По всему дому, в лифте, внутреннем дворе и паркинге установлены усилители сигнала сотовой связи, гарантирующие устойчивую связь. А скоростной лифт легко доставит вас к автомобилю, въезд которого контролируется умной системой распознавания номеров.',
      active: false,
    },
  ],

  roomsInfo: [
    {
      id: 0,
      src: Img5,
      plug: Plug4,
      srcMob: Img5xs,
      title: 'Студии',
      area: '25,78',
      active: true,
      description:
        'Сбалансированные студии с&nbsp;полноценной ванной и&nbsp;балконом. Здесь достаточно места, чтобы устроить тёплую ламповую вечеринку для самых близких друзей.',
    },
    {
      id: 1,
      plug: Plug3,
      src: Img4,
      srcMob: Img4xs,
      title: '1-спальные',
      area: '37,75',
      active: false,
      description:
        'Необычные односпальные квартиры с&nbsp;двумя санузлами. Гостиная евро-формата плюс отдельная мастер-спальня&nbsp;&mdash; проверенная формула для комфортной жизни вдвоем.',
    },
    {
      id: 2,
      plug: Plug1,
      src: Img2,
      srcMob: Img2xs,
      title: '2-спальные',
      area: '61,01',
      active: false,
      description:
        'Ещё больше личного пространства и&nbsp;ежедневного комфорта, который оценят как дети, так и&nbsp;родители. Угловые квартиры подарят дополнительное окно в&nbsp;спальне или детской.',
    },
    {
      id: 3,
      plug: Plug5,
      src: Img11,
      srcMob: Img11xs,
      title: '3-спальные',
      area: '82,28',
      active: false,
      description:
        'Мастер-спальня с&nbsp;отдельным санузлом и&nbsp;гардеробной. Своё пространство для старших и&nbsp;младших. Большая гостиная для дружных семейных обедов и&nbsp;кинопросмотров. Любимые бабушки и&nbsp;дедушки смогут свободно у&nbsp;вас погостить.',
    },
    {
      id: 4,
      plug: Plug2,
      src: Img3,
      srcMob: Img3xs,
      title: '4-спальные',
      area: '113,93',
      active: false,
      description:
        'Самая настоящая семейная резиденция. По&nbsp;два окна в&nbsp;спальне и&nbsp;в&nbsp;гостиной обеспечат максимальное удовольствие от&nbsp;видов и&nbsp;полную свободу для интересных интерьерных решений. Уединённая мастер-спальня с&nbsp;гардеробной и&nbsp;три санузла&nbsp;&mdash; домашним удобно, гостям понравится.',
    },
  ],

  panoramas: [
    {
      id: 0,
      title: 'утро',
      img: PanoramaMorning,
      imgMob: PanoramaMorning,
      active: true,
    },
    {
      id: 1,
      title: 'день',
      img: PanoramaAfternoon,
      imgMob: PanoramaAfternoon,
      active: false,
    },
    {
      id: 2,
      title: 'вечер',
      img: PanoramaEvening,
      imgMob: PanoramaEvening,
      active: false,
    },
  ],
  flat: {
    deadline: 'Срок сдачи 31 июля 2024',
    listDeadline: 'II кв 2023',
    quarter: 'Квартал Некрасовка',
  },
  menuLeft: null,
  menuRight: null,
  footerLeft: null,
  footerRight: null,
  footerMiddle: null,
  developers: null,
  headerKeysData: null,
  fetchError: false,
  promoCards: null,
  generalSettings: null,
  policyForm: {
    caption: '',
    checkbox: '',
  },
  cookie: {
    title: '',
    description: '',
  },
  mortgageCalculatorName: 'finch',
};

export const ProjectSlice = createSlice({
  name: 'projectinfo',
  initialState,
  reducers: {
    hydrate: (state, action) => ({ ...state, ...action.payload }),
    changeRoomsAreas: (state, action) => {
      state.roomsInfo = state.roomsInfo.map(item => ({
        ...item,
        area: action.payload[item.id] !== 0 ? action.payload[item.id] : item.area,
      }));
    },
    changeActiveSlide: (state, action) => {
      const newState = state.slider.map(item => {
        if (item.id === action.payload) {
          item.active = true;
        } else item.active = false;
        return item;
      });
      state.slider = newState;
    },

    changeActiveRooms: (state, action) => {
      const newState = state.roomsInfo.map(item => {
        if (item.id === action.payload) {
          item.active = true;
        } else item.active = false;
        return item;
      });

      state.roomsInfo = newState;
    },

    changeActivePanorama: (state, action) => {
      const newState = state.panoramas.map(item => {
        if (item.id === action.payload) {
          item.active = true;
        } else item.active = false;
        return item;
      });

      state.panoramas = newState;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMenuLeft.fulfilled, (state, action) => {
        state.menuLeft = action.payload;
      })
      .addCase(fetchMenuLeft.rejected, state => {
        state.fetchError = true;
      })
      .addCase(fetchMenuRight.fulfilled, (state, action) => {
        state.menuRight = action.payload;
      })
      .addCase(fetchMenuRight.rejected, state => {
        state.fetchError = true;
      })
      .addCase(fetchFooterRight.fulfilled, (state, action) => {
        state.footerRight = action.payload;
      })
      .addCase(fetchFooterRight.rejected, state => {
        state.fetchError = true;
      })
      .addCase(fetchDevelopers.fulfilled, (state, action) => {
        state.developers = action.payload?.[0]?.settings || null;
      })
      .addCase(fetchDevelopers.rejected, state => {
        state.fetchError = true;
      })
      .addCase(fetchFooterMiddle.fulfilled, (state, action) => {
        state.footerMiddle = action.payload;
      })
      .addCase(fetchFooterMiddle.rejected, state => {
        state.fetchError = true;
      })
      .addCase(fetchFooterLeft.fulfilled, (state, action) => {
        state.footerLeft = action.payload;
      })
      .addCase(fetchFooterLeft.rejected, state => {
        state.fetchError = true;
      })
      .addCase(fetchPromoCards.fulfilled, (state, action) => {
        state.promoCards = action.payload;
      })
      .addCase(fetchHeaderKeysData.fulfilled, (state, action) => {
        state.headerKeysData = action.payload;
      })
      .addCase(fetchPromoCards.rejected, state => {
        state.fetchError = true;
      })
      .addCase(fetchGeneralSettings.fulfilled, (state, action) => {
        state.generalSettings = action.payload;

        const policyData = action.payload?.find(i => i.setting_name === 'policy_form_text_moments') || {};
        if (!policyData.hidden) {
          for (const item of policyData?.settings ?? []) {
            if (item.value?.includes('policy')) {
              state.policyForm.caption = item.name;
            } else if (item.value?.includes('ads-consent')) {
              state.policyForm.checkbox = item.name;
            }
          }
        }

        const cookieData = action.payload?.find(i => i.setting_name === 'cookie_moments') || {};
        if (!cookieData.hidden && Array.isArray(cookieData?.settings)) {
          const settings = cookieData?.settings;

          // [0] всегда будет title
          state.cookie.title = settings[0]?.name;

          // Все остальные — фильтруем и склеиваем HTML
          const descriptionHTML = settings
            .slice(1)
            .map(item => item.name)
            .join('<br>');

          state.cookie.description = descriptionHTML;
        }

        const settingsCalculator =
          action.payload?.find(setting => setting.setting_name === 'calculate-visible') || undefined;

        if (!settingsCalculator) state.mortgageCalculatorName = 'finch';

        const isCalculatorOff = settingsCalculator?.settings?.every(program => program.value === 'false') ?? false;

        const alternativeCalculatorName = isCalculatorOff ? null : state.mortgageCalculatorName;

        const { name: foundName } = settingsCalculator?.settings
          ?.sort((a, b) => a.order - b.order)
          ?.find(program => {
            const normalizeProgramType = program.value.trim();

            return normalizeProgramType === 'true';
          }) ?? { name: alternativeCalculatorName };

        state.mortgageCalculatorName = foundName;
      })
      .addCase(fetchGeneralSettings.rejected, state => {
        state.fetchError = true;
      });
  },
});

export const { changeActiveSlide, changeActiveRooms, changeActivePanorama, changeRoomsAreas } = ProjectSlice.actions;

export const menuLeftSelector = state => state.projectinfo.menuLeft;
export const menuRightSelector = state => state.projectinfo.menuRight;
export const footerLeftSelector = state => state.projectinfo.footerLeft;
export const footerMiddleSelector = state => state.projectinfo.footerMiddle;
export const footerRightSelector = state => state.projectinfo.footerRight;
export const developersSelector = state => state.projectinfo.developers;
export const promoCardsSelector = state => state.projectinfo.promoCards;
export const generalSettingsSelector = state => state.projectinfo.generalSettings;
export const policyFormSelector = state => state.projectinfo.policyForm;
export const cookieContentSelector = state => state.projectinfo.cookie;

export default ProjectSlice.reducer;
